import React from 'react';

type StatusType =
  | 'admitted' |'active' |'critical' |'discharged' |'scheduled' |'pending' |'completed' |'cancelled' |'available' |'occupied' |'maintenance' |'in-progress' |'no-show' |'under-treatment' |'transferred' |'processing' |'results-ready' |'on-duty' |'off-duty';

interface StatusBadgeProps {
  status: StatusType | string;
  size?: 'sm' | 'md';
  className?: string;
}

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  admitted: { label: 'Admitted', className: 'status-badge-admitted' },
  active: { label: 'Active', className: 'status-badge-active' },
  critical: { label: 'Critical', className: 'status-badge-critical' },
  discharged: { label: 'Discharged', className: 'status-badge-discharged' },
  scheduled: { label: 'Scheduled', className: 'status-badge-scheduled' },
  pending: { label: 'Pending', className: 'status-badge-pending' },
  completed: { label: 'Completed', className: 'status-badge-active' },
  cancelled: { label: 'Cancelled', className: 'status-badge-discharged' },
  available: { label: 'Available', className: 'status-badge-active' },
  occupied: { label: 'Occupied', className: 'status-badge-admitted' },
  maintenance: { label: 'Maintenance', className: 'status-badge-pending' },
  'in-progress': { label: 'In Progress', className: 'status-badge-admitted' },
  'no-show': { label: 'No Show', className: 'status-badge-critical' },
  'under-treatment': { label: 'Under Treatment', className: 'status-badge-admitted' },
  transferred: { label: 'Transferred', className: 'status-badge-pending' },
  processing: { label: 'Processing', className: 'status-badge-pending' },
  'results-ready': { label: 'Results Ready', className: 'status-badge-active' },
  'on-duty': { label: 'On Duty', className: 'status-badge-active' },
  'off-duty': { label: 'Off Duty', className: 'status-badge-discharged' },
};

export default function StatusBadge({ status, size = 'md', className = '' }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: 'status-badge-discharged' };
  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2.5 py-1';

  return (
    <span data-component-id="src/components/ui/StatusBadge.tsx:39:4" data-component-path="src/components/ui/StatusBadge.tsx" data-component-line="39" data-component-end-line="43" data-component-file="StatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
      className={`inline-flex items-center rounded-full font-600 ${sizeClass} ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}